// extracted by mini-css-extract-plugin
module.exports = {"root":"Option_root__3TakW","row":"Option_row__1ddhL"};